import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuthStore from "../../store/authStore";
import {
  PARTNER_ADMIN_HOME,
  canAccessAdminPath,
  isAdminWebRole,
  isPartnerRole,
} from "../../utils/adminAccess";

function ProtectedRoute() {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  if (!token || !user || !isAdminWebRole(user)) {
    return <Navigate to="/login" replace />;
  }

  if (isPartnerRole(user) && location.pathname === "/admin") {
    return <Navigate to={PARTNER_ADMIN_HOME} replace />;
  }

  if (!canAccessAdminPath(user, location.pathname)) {
    return <Navigate to={PARTNER_ADMIN_HOME} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
